// hooks
import { useMetamask } from 'contexts/Metamask'
import useInput from 'hooks/useInput'
import useSwitch from 'hooks/useSwitch'

// libraries
import { toast } from 'react-toastify'
import { CSVReader } from "react-papaparse"

// components
import Button from 'components/Button'
// import DatePicker from "react-datepicker";

// helpers
import { stringToDate, toUnixTimestamp } from 'utilities/utils'
import { validateAmount } from 'utilities/validate'
import { APP_CONFIG, ContractAddress } from 'config'
import Contracts from 'helpers/contracts'

import classes from './VestToken.module.scss'
import { useState } from 'react'

export default function VestToken() {
  const { account, isConnectedToAllowedNetwork, handleTransactionError } = useMetamask()

  const walletAddress = useInput()
  const startDate = useInput()
  const endDate = useInput()

  const [batchData, setBatchData] = useState<any>({
    address: [],
    amount: [],
  })

  // const [startDate, setStartDate] = useState(new Date());
  // const [endDate, setEndDate] = useState(new Date());
  const amount = useInput()
  const isTransactionInProgress = useSwitch()

  const onUpload = (dt: any) => {
    dt.shift() // remove first row having names
    let addressArray: any[] = []
    let amountArray: any[] = []
    console.log(dt)
    dt.map((userData: any) => {
      console.log(userData.data[0], userData.data[1])
      addressArray.push(userData.data[0])
      amountArray.push(userData.data[1])
    })
    setBatchData({
      address: addressArray,
      amount: amountArray,
    })
  }

  const processTransaction = async (walletAddress: any, amt: any) => {
    try {
      isTransactionInProgress.true()
      const UNIXStartDate = toUnixTimestamp(new Date(startDate.value))
      const UNIXEndDate = toUnixTimestamp(new Date(endDate.value))
      if (UNIXStartDate > UNIXEndDate) {
        toast.error("START date cannot be after END Date")
        isTransactionInProgress.false()
        return
      }
      let totalAmount = 0
      if (Array.isArray(amt)) {
        for (let idx = 0;idx < amt.length;idx++) {
          totalAmount += parseFloat(amt[idx])
        }
      } else {
        totalAmount = parseFloat(amt)
        amt = BigInt(parseFloat(amt) * 1e18)
      }

      const _amount = BigInt(totalAmount * 1e18)
      let unlock: string[] = []
      let start: number[] = []
      let end: number[] = []
      for (let idx = 0;idx < amt.length;idx++) {
        amt[idx] = BigInt(parseFloat(amt[idx]) * 1e18)
        unlock.push("0")
        start.push(UNIXStartDate)
        end.push(UNIXEndDate)
      }
      await Contracts.instances.Token?.methods
        .approve(ContractAddress.Vesting, _amount.toString())
        .send({ from: account })

      let callableNFT: any
      if (Array.isArray(amt)) {
        callableNFT = Contracts.instances.Vesting?.methods.createBatchClaim(
          walletAddress,
          amt,
          unlock,
          unlock,
          start,
          end
        )

      } else {
        callableNFT = Contracts.instances.Vesting?.methods.createClaim(
          walletAddress,
          _amount.toString(),
          0,
          0,
          UNIXStartDate,
          UNIXEndDate
        )
      }

      await callableNFT?.send({ from: account })
      toast.success("Claim Created")
    } catch (err) {
      console.log(err)
      toast.error("Could not create claim.")
    }
    isTransactionInProgress.false()
  }

  const processWithdrawPendingTokenTransaction = async (walletAddress: any) => {
    try {
      isTransactionInProgress.true()

      const callableNFT = Contracts.instances.Vesting?.methods.withdrawPendingToken(
        walletAddress
      )
      await callableNFT?.send({ from: account })
      toast.success("sucess")
    } catch (err) {
      console.log(err)
      toast.error("error")
    }
    isTransactionInProgress.false()
  }

  const processWithdrawTokensTransaction = async () => {
    try {
      isTransactionInProgress.true()

      const callableNFT = Contracts.instances.Vesting?.methods.withdrawTokens()
      await callableNFT?.send({ from: account })
      toast.success("sucess")
    } catch (err) {
      console.log(err)
      toast.error("error")
    }
    isTransactionInProgress.false()
  }


  const batchVest = async () => {
    if (!startDate.value || !endDate.value) {
      return toast.error("Please add the start date and the end date")
    }
    batchData.amount.forEach((amountTuple: any, idx: any) => {
      if (!validateAmount(amountTuple)) {
        return toast.error(`Amount not valid for ${batchData.address[idx]}`)
      }
    })
    await processTransaction(batchData.address, batchData.amount)
  }

  const vestTokens = async () => {
    if (!(await isConnectedToAllowedNetwork())) return

    if (!walletAddress.value || !startDate.value || !endDate.value || !amount.value) {
      return toast.error('Please fill all the fields')
    }

    if (!validateAmount(amount.value)) return

    await processTransaction(walletAddress.value, amount.value)
  }

  const withdrawAllTokens = async () => {
    if (!(await isConnectedToAllowedNetwork())) return
    await processWithdrawTokensTransaction()
  }

  const withdrawPendingToken = async () => {
    if (!(await isConnectedToAllowedNetwork())) return

    if (!walletAddress.value) {
      return toast.error('Please fill the wallet address field')
    }
    await processWithdrawPendingTokenTransaction(walletAddress.value)
  }

  return (
    <div className={classes.block}>
      <table>
        <tbody>
          <tr className={classes.inputRow}>
            <td className={classes.label}>Start Time</td>
            <td>
              <input
                value={startDate.value}
                onChange={startDate.set}
                className={classes.input}
                type="datetime-local"
                disabled={isTransactionInProgress.value}
              />
              {/* <DatePicker
                  selected={startDate}
                  onChange={(e:any)=>setStartDate(e)}
                  className={classes.input}
                  timeInputLabel="Time:"
                  dateFormat="MM/dd/yyyy h:mm aa"
                  disabled={isTransactionInProgress.value}
                  showTimeInput
                /> */}
            </td>
          </tr>
          <tr className={classes.inputRow}>
            <td className={classes.label}>End Time</td>
            <td>
              <input
                value={endDate.value}
                onChange={endDate.set}
                className={classes.input}
                type="datetime-local"
                disabled={isTransactionInProgress.value}
              />
              {/* <DatePicker
                selected={endDate}
                onChange={(e:any)=>setEndDate(e)}
                className={classes.input}
                timeInputLabel="Time:"
                dateFormat="MM/dd/yyyy h:mm aa"
                disabled={isTransactionInProgress.value}
                showTimeInput
              /> */}
            </td>
          </tr>
          <tr className={classes.inputRow}>
            <td className={classes.label}>Wallet Address</td>
            <td>
              <input
                value={walletAddress.value}
                onChange={walletAddress.set}
                className={classes.input}
                disabled={isTransactionInProgress.value}
                placeholder="Wallet Address (0x...)"
              />
            </td>
          </tr>
          <tr className={classes.inputRow}>
            <td className={classes.label}>Amount {APP_CONFIG.VESTING_TOKEN}</td>
            <td>
              <input
                type="number"
                value={amount.value}
                onChange={amount.set}
                className={classes.input}
                disabled={isTransactionInProgress.value}
                placeholder="0000"
              />
            </td>
          </tr>
          <tr className={classes.inputRow}>
            <td className={classes.label}>Upload CSV</td>
            <td>
              <CSVReader onFileLoad={onUpload} />
            </td>
          </tr>
        </tbody>
      </table>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}>
        <Button
          text={`Vest ${APP_CONFIG.VESTING_TOKEN}`}
          className={classes.button}
          onClick={async () => {
            if (batchData.address.length === 0) vestTokens()
            else batchVest()
          }}
          loading={isTransactionInProgress.value}
        />
        <Button
          text={`withdraw all`}
          className={classes.button}
          onClick={async () => {
            withdrawAllTokens()
          }}
          loading={isTransactionInProgress.value}
        />
        <Button
          text={`withdraw`}
          className={classes.button}
          onClick={async () => {
            withdrawPendingToken()
          }}
          loading={isTransactionInProgress.value}
        />
      </div>
    </div>
  )
}
